exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CleverAccessTokenDetailsPage .displayToggleControl{margin-top:20px;margin-bottom:20px;font-size:15px}.CleverAccessTokenDetailsPage .CleverSyncDistrictData .sync-action{margin-right:20px;margin-top:20px}.CleverAccessTokenDetailsPage a{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/clever_access_token_details_page.scss
// module id = 819
// module chunks = 0